import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Checkbox, Grid } from '@mui/material'

import Dialog from './Dialog'
import InputField from './InputField'
import GridHeader from './GridHeader'
import ButtonRunDownload from './ButtonRunDownload'
import {
  useGetArbitroByIdQuery,
  useUpdateArbitroAutocertificazioneMutation,
} from '../hooks/api-slice'

const VALUES_PREVIDENZA = ['no', 'sì']
const VALUES_PUBBLICO = ['no', 'sì-sì', 'sì-no']

const DialogAutocertificazione = ({ open, handleClose }) => {
  const { idArbitro } = useSelector(state => state.home.infoUtente)

  const { data: arbitroData } = useGetArbitroByIdQuery(idArbitro, {
    skip: !idArbitro,
  })

  const { ultimaAutocertificazione } = arbitroData || {}

  const [updateArbitroAutocertificazioneMutation] =
    useUpdateArbitroAutocertificazioneMutation()

  const [importo1, setImporto1] = useState()
  const [importo2, setImporto2] = useState()
  const [checkPrevidenza, setCheckPrevidenza] = useState()
  const [checkPubblico, setCheckPubblico] = useState()

  const updateAutocertificazione = async () => {
    const body = { importo1, importo2, checkPrevidenza, checkPubblico }
    const arg = { id: arbitroData?._id, ...body }
    await updateArbitroAutocertificazioneMutation(arg).unwrap()
  }

  useEffect(() => {
    if (open) {
      setImporto1(ultimaAutocertificazione?.importo1)
      setImporto2(ultimaAutocertificazione?.importo2)
      setCheckPrevidenza(ultimaAutocertificazione?.checkPrevidenza)
      setCheckPubblico(ultimaAutocertificazione?.checkPubblico)
    }
  }, [open, ultimaAutocertificazione])

  const containerProps = {
    container: true,
    paddingY: 1,
    alignItems: 'center',
    sx: { width: '100%' },
  }

  const GridInputImporto = (id, value, onChange) => (
    <Grid size={{ xs: 12, md: 3 }}>
      <InputField
        id={id}
        label='Importo lordo'
        value={value}
        onChange={x => onChange(+x?.toFixed(2))}
        type='number'
      />
    </Grid>
  )

  const GridCheckboxPrevidenza = value => (
    <Grid size={{ xs: 2, md: 1 }}>
      <center>
        <Checkbox
          id={`check-previdenza-${value}`}
          checked={checkPrevidenza === value}
          onChange={event =>
            setCheckPrevidenza(!!event.target.checked ? value : undefined)
          }
        />
      </center>
    </Grid>
  )

  const GridCheckboxPubblico = value => (
    <Grid size={{ xs: 2, md: 1 }}>
      <center>
        <Checkbox
          id={`check-pubblico-${value}`}
          checked={checkPubblico === value}
          onChange={event =>
            setCheckPubblico(!!event.target.checked ? value : undefined)
          }
        />
      </center>
    </Grid>
  )

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      title='Autocertificazione'
      maxWidth='md'
    >
      <Grid container {...containerProps}>
        <GridHeader noCenter text='Dichiarazione compensi' />
        <Grid size={{ xs: 12, md: 9 }}>
          Nell'anno solare in corso, riceverò compensi da soggetti diversi da
          PGS per prestazioni di lavoro sportivo dilettantistico e
          collaborazione amministrativo-gestionale per un importo lordo pari a
        </Grid>
        {GridInputImporto('importo1', importo1, setImporto1)}
        <Grid size={{ xs: 12, md: 9 }}>
          Nell'anno solare in corso, per la parte previdenziale ho utilizzato o
          utilizzerò la soglia di non imponibilità di € 5.000 con soggetti
          diversi da PGS per un importo lordo pari a
        </Grid>
        {GridInputImporto('importo2', importo2, setImporto2)}
      </Grid>
      <Grid {...containerProps}>
        <GridHeader noCenter text='Dichiarazione previdenza' />
        {GridCheckboxPrevidenza(VALUES_PREVIDENZA[0])}
        <Grid size={{ xs: 10, md: 11 }}>
          NON sono iscritto in altre forme di previdenza diverse da quelle della
          gestione separata INPS.
        </Grid>
        {GridCheckboxPrevidenza(VALUES_PREVIDENZA[1])}
        <Grid size={{ xs: 10, md: 11 }}>
          Sono iscritto in altre forme di previdenza diverse da quelle della
          gestione separata INPS.
        </Grid>
      </Grid>
      <Grid {...containerProps}>
        <GridHeader noCenter text='Dichiarazione dipendenti pubblici' />
        {GridCheckboxPubblico(VALUES_PUBBLICO[0])}
        <Grid size={{ xs: 10, md: 11 }}>NON sono dipendente pubblico.</Grid>
        {GridCheckboxPubblico(VALUES_PUBBLICO[1])}
        <Grid size={{ xs: 10, md: 11 }}>
          Sono dipendente pubblico e ho ricevuto autorizzazione per lo
          svolgimento di lavoro sportivo.
        </Grid>
        {GridCheckboxPubblico(VALUES_PUBBLICO[2])}
        <Grid size={{ xs: 10, md: 11 }}>
          Sono dipendente pubblico e NON ho ricevuto autorizzazione per lo
          svolgimento di lavoro sportivo.
        </Grid>
      </Grid>
      <ButtonRunDownload
        buttonText='Scarica'
        algorithm='16_GenerateExcelAutocertificazione'
        type='XLSX'
        preRun={updateAutocertificazione}
      />
    </Dialog>
  )
}

export default DialogAutocertificazione
